import React from "react";
import {
  Box, Typography, TextField, InputAdornment, CircularProgress, Button
} from "@mui/material";
import { Search, Refresh } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const UsersHeader = ({ q, setQ, refreshing, onRefresh }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
      <Typography variant="h4" sx={{ flexGrow: 1 }}>
        {t("usersHeader.title", "Users")}
      </Typography>

      <TextField
        size="small"
        placeholder={t("usersHeader.searchPlaceholder", "Search users...")}
        value={q}
        onChange={(e) => setQ(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search fontSize="small" />
            </InputAdornment>
          ),
        }}
      />

      <Button
        variant="outlined"
        onClick={onRefresh}
        disabled={refreshing}
        startIcon={refreshing ? <CircularProgress size={16} /> : <Refresh />}
      >
        {t("usersHeader.refresh", "Refresh")}
      </Button>
    </Box>
  );
};

export default UsersHeader;